"use strict";

var Backbone = require("backbone");
var _ = require("underscore");
var BaseModel = require("../../common/models/base-model");

var debug = require("debug")("models:BookmarksModel");    //https://github.com/visionmedia/debug

/**
 * BookmarksModel
 */
module.exports = BaseModel.extend({

    pv5api: null,
    mtime: 0,

    defaults: {
        documentId: 0,
        publicationId: 0,
        bookmarks: null,
        bookmarksPerPage: null
    },

    initialize: function (attributes, options) {
        BaseModel.prototype.initialize.apply(this, arguments);
        debug("initialize");
        _.extend(this, options);
    },

    url: function () {
        var T = this,
            url = T.pv5api + "/document/" + T.get("publicationId") + "/" + T.get("documentId") + "/bookmarks",
            query_string = [];
        if (T.mtime) {
            query_string.push("mt=" + T.mtime);
        }
        return T.addQueryStringArrayToUrl(url, query_string);
    },

    parse: function (response) {
        // parse xml
        var $ = Backbone.$;
        var $xml = $(response);
        var $bookmarks = $xml.find("bookmark");

        var all_bookmarks = [];
        var order = 1;
        var level = 0;
        var parents = [];
        $bookmarks.each(function () {
            var $bookmark = $(this);
            var $parent_bm = $bookmark.parent().closest("bookmark");
            var parent_level = Number($parent_bm.attr("level"));
            var level = parent_level + 1 || 0;
            $bookmark.attr("level", level);

            var new_bookmark = {
                title: $bookmark.find("title:first").text(),
                page: Number($bookmark.find("destination:first").attr("page")),
                level: level,
                order: order
            }
            parents[level] = new_bookmark;

            if (level > 0) {
                new_bookmark.parent = parents[parent_level];
            }

            all_bookmarks.push(new_bookmark);

            order++;
        });

        var bookmarks_per_page = all_bookmarks.map(function (bm) { return bm });

        // sort per page and order
        bookmarks_per_page.sort(function (bm_a, bm_b) {
            if (bm_a.page > bm_b.page) {
                return 1;
            }
            else if (bm_a.page < bm_b.page) {
                return -1;
            }
            else {
                // même page on trie par order
                return bm_a.order - bm_b.order;
            }

        });

        // les bookmarks sont forcément rangés par page croissante dans le pdf
        //console.table(all_bookmarks);
        //console.table(bookmarks_per_page);


        return {
            bookmarks: all_bookmarks,
            bookmarksPerPage: bookmarks_per_page
        };
    },

    /**
     * Retourne le bookmark correspondant à la page demandée ainsi que le path vers ce bookmark
     * @param {Number} page 
     */
    getPageBookmark: function (page) {
        var bms = this.get("bookmarksPerPage");

        // binary search, must be sorter
        // https://stackoverflow.com/questions/4431259/formal-way-of-getting-closest-values-in-array-in-javascript-given-a-value-and-a/4431347
        var lo = -1, hi = bms.length;
        while (hi - lo > 1) {
            var mid = Math.round((lo + hi) / 2);
            if (bms[mid].page <= page) {
                lo = mid;
            } else {
                hi = mid;
            }
        }

        var parents = [];
        var bookmark = bms[lo];

        if (bookmark) {

            // on s'assure qu'il n'y a pas un niveau inférieur avec la même page
            var desc_index = lo + 1;
            while (desc_index < bms.length) {
                if (bms[desc_index].page == bookmark.page) {
                    bookmark = bms[desc_index];
                }
                else {
                    break;
                }
                desc_index++;
            }

            // remonte la chaine de parents pour avoir le path 
            var bm_it = bookmark;
            while (bm_it.parent) {
                parents.push(bm_it.parent.title);
                bm_it = bm_it.parent;
            }
        }

        return {
            bookmark: bookmark,
            parents: parents.reverse()
        }
    },

    fetch: function (options) {
        options = options || {};
        options.dataType = "xml";
        return BaseModel.prototype.fetch.call(this, options);
    }

});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@immanens-com/pv5js/reader/models/bookmarks-model.js
// module id = 55
// module chunks = 0